import { render, staticRenderFns } from "./popContentSider.vue?vue&type=template&id=be19e54e&scoped=true"
import script from "./popContentSider.vue?vue&type=script&setup=true&lang=js"
export * from "./popContentSider.vue?vue&type=script&setup=true&lang=js"
import style0 from "./popContentSider.vue?vue&type=style&index=0&id=be19e54e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be19e54e",
  null
  
)

export default component.exports